import { render, staticRenderFns } from "./BreakTimeModal.vue?vue&type=template&id=b6632406&scoped=true&"
import script from "./BreakTimeModal.vue?vue&type=script&lang=js&"
export * from "./BreakTimeModal.vue?vue&type=script&lang=js&"
import style0 from "./BreakTimeModal.vue?vue&type=style&index=0&id=b6632406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6632406",
  null
  
)

export default component.exports